// src/components/LoadingOverlay.jsx
import React from "react";

const LoadingOverlay = () => {
    return (
        <div
            id="loading-overlay"
            style={{
                backdropFilter: "blur(10px)"
            }}
            className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-50 z-50 hidden "
        >
            <video
                src="/loading.mp4"
                autoPlay
                loop
                muted
                style={{
                    width: "512px",
                    height: "512px",
                    opacity: "0.45",
                }}
            />
        </div>
    );
};

export default LoadingOverlay;
